import { Pipe, PipeTransform } from '@angular/core';

import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Observable } from 'rxjs';

import { ConfigurationService } from '../../configuration.service';

@Pipe({
  name: 'docsByCond',
  standalone: false,
})
export class DocsByCondPipe implements PipeTransform {

  projectId: string;

  constructor(
    private angularFirestore: AngularFirestore,
    private configurationService: ConfigurationService,
  ) {
    this.projectId = this.configurationService.getProjectId();
  }

  transform(value: string, collectionName: string, fieldName: string): Observable<any> {
    return this.angularFirestore.collection(
      `${collectionName}`, ref => ref.where('project_id', '==', this.projectId).where(fieldName, '==', value).limit(1)).valueChanges();
  }

}
